module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Github-720a880d23c9e83fcf2d96553d118a7e.svg";